import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { LoadTemplates } from '../../actions';
import { getDraftMessage } from '../../helpers/conversations-draft.helper';
import setToast from '../../helpers/toaster.helper';
import { AddContactPrimaryIcon, BlockIcon, EditContactIcon, TrashIcon } from '../../icon';
import { Contact, ConversationCardModel, } from '../../models/conversations';
import { TemplateModel } from '../../models/templates.models';
import * as selector from '../../selectors/selectors';
import { ContactService } from '../../services/ContactService';
import { UtilityService } from '../../services/UtilityService';
import ContactView from "../contacts/contact-view.component";
import ConfirmDialog from '../shared/confirm-dialog.component';
import { ActionLabels, ToasterTexts, appNote, buttonLabels, pageTitles } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';
import ContactInfoComponent from './contact-info.component';
import ConversationHistoryHeader from './conversation-history-header';
import ConversationHistoryPage from './conversation-history-page';
import MessageComposer from './message-composer';
import ScheduleMsgMobileComponent from './schedule-msg-mobile-component';
import SendMessage from "./send-message-component";
import TransferConversationChat from './transfor-chat';
import ContactInfoComponentNew from './contact-info.newcomponent';

interface Props {
    CardData: ConversationCardModel;
    IsMobileDevice: boolean;
    IsDisabled: boolean;
    ActiveCardIndex: number;
    BackHandler: () => void
    UnreadCount: number;
    scrollRef: React.MutableRefObject<any>;
    pathName: string;
    editorState?: any;
    activeCardIndex?: number;
    deviceHeight: number;
    onEditScheduleChange?: (value: boolean, id?: any) => void;
    onOpenContactInfo?: (data?: any) => void;
    DuplicateSchedule?: (scheduleID: string, participantId?: string) => void;
    onCloseContactInfo?: () => void;

}

const ConverstionHistory = (props: Props) => {
    const dispatch = useDispatch()
    const Templates: TemplateModel[] = useSelector(selector.templates);
    const DeviceHeight: number = useSelector(selector.deviceHeight);
    const GetUnSubscribedContacts: Contact[] = useSelector(selector.getUnSubscribedContacts);
    const { GroupChat, IsBlocked, PhoneNumber, MaskedPhoneNumber, Contact, Campaign } = props.CardData
    const [openForwordMessage, setOpenForwordMessage] = useState<boolean>(false)
    const [media, setMedia] = useState<any>()
    const [message, setMessage] = useState<string>("")
    const [showContactInfo, setShowContactInfo] = useState<boolean>(false)
    const [openEditContact, setOpenEditContact] = useState<boolean>(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)
    const [text, setText] = useState<string>("")
    const [dailogButtonName, setDailogButtonName] = useState<string>("")
    const [dialogAction, setDialogAction] = useState<string>("")
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [isMobileSchedule, setIsMobileSchedule] = useState<boolean>(false);
    const [scheduleDateTime, setScheduleDateTime] = useState<number>(-1);
    const [selectedScheduleType, setSelectedScheduleType] = useState<number>(props.CardData.msgType === "secure-chat" ? 1 : 0);
    const [number, setNumber] = useState<string>();

    const [suggestionMessage, setSuggestionMessage] = useState<string>("")
    const [showTransferChat, setShowTransferChat] = useState<boolean>(false)

    // useEffect(() => {
    //     if (Templates.length === 0) {
    //         LoadTemplates(dispatch);
    //     }
    // }, [])

    useEffect(() => {
        if (number !== props.CardData?.PhoneNumber) {
            const message = getDraftMessage(props.CardData?.PhoneNumber || "");
            setNumber(props.CardData?.PhoneNumber);
            setMessage(message)
        }
    }, [props.CardData])

    const openForwardMessage = (media, msg) => {
        setOpenForwordMessage(true)
        setMedia(media);
        setMessage(msg)
    }
    const closeForwardMessage = () => {
        setOpenForwordMessage(false)
        setMedia([]);
        setMessage("")
    }

    const handelContactInfomobile = (isConfim: boolean) => {
        setShowContactInfo(isConfim)
    }

    // const handleEditContact = () => {
    //     setShowContactInfo(false)
    //     setOpenEditContact(true)
    // }

    // const closeEditContact = () => {
    //     setOpenEditContact(false)
    //     setShowContactInfo(true)
    // }

    // const openConfirmDialog = () => {
    //     if (props.IsMobileDevice) {
    //         setShowContactInfo(true)
    //     }
    //     else {
    //         setShowContactInfo(false)
    //     }
    //     setShowConfirmDialog(true)
    //     setText(appNote.CONTACT_DELETE)
    //     setDailogButtonName(buttonLabels.DELETE)
    //     setDialogAction("Delete")
    //     setIsLoading(false)
    // }

    // const openBlockConfirmDialog = (isBlocked: boolean) => {
    //     if (props.IsMobileDevice) {
    //         setShowContactInfo(true)
    //     }
    //     else {
    //         setShowContactInfo(false)
    //     }
    //     setShowConfirmDialog(true)
    //     setText(isBlocked ? appNote.UNBLOCK_CONTACT : appNote.BLOCK_CONTACT)
    //     setDailogButtonName(isBlocked ? buttonLabels.UNBLOCK : buttonLabels.BLOCK)
    //     setDialogAction("Blocked")
    //     setIsLoading(false)
    // }

    // const closeConfirmDialog = (isConfim: any) => {
    //     if (!!isConfim && (dialogAction == "Delete" || dialogAction == "Blocked")) {
    //         let Name = Contact?.Name ? Contact?.Name : Contact?.PhoneNumber;
    //         setIsLoading(true);
    //         var apiCall = (dialogAction === "Delete")
    //             ? ContactService.deleteContact(Contact?.ID, false)
    //             : ContactService.blockUnBlockNumber(PhoneNumber.replace('+', ''), !IsBlocked);

    //         apiCall.then(() => {
    //             if (dialogAction === "Delete") {
    //                 setToast(ToasterTexts.CONTACT_DELETE_SUCCESS.replace('<Name>', Name || PhoneNumber), ToasterType.SUCCESS);
    //             } else {
    //                 setToast(!IsBlocked ? ToasterTexts.CONTACT_BLOCK_SUCCESS.replace('<Name>', Name || PhoneNumber) : ToasterTexts.CONTACT_UNBLOCK_SUCCESS.replace('<Name>', Name || PhoneNumber), ToasterType.SUCCESS);
    //             }
    //             setShowConfirmDialog(false);
    //             setText("");
    //             setDialogAction("");
    //         });
    //     }
    //     else {
    //         setShowConfirmDialog(false)
    //         setText("")
    //         setDialogAction("")
    //         setIsLoading(false)
    //     }
    // }
    // const contactActionData = React.useMemo(() => [
    //     {
    //         Name: !!Contact?.ID ? ActionLabels.EDIT_CONTACT : ActionLabels.ADD_CONTACT,
    //         Icon: !!Contact?.ID ? EditContactIcon : AddContactPrimaryIcon,
    //         Hide: Contact?.IsUnsubscribed,
    //         OnClick: () => handleEditContact(),
    //     },
    //     {
    //         Name: IsBlocked ? ActionLabels.UNBLOCK_CONTACT : ActionLabels.BLOCK_CONTACT,
    //         Icon: BlockIcon,
    //         OnClick: () => openBlockConfirmDialog(IsBlocked),
    //     },
    //     {
    //         Name: ActionLabels.DELETE_CONTACT,
    //         Icon: TrashIcon,
    //         OnClick: () => openConfirmDialog(),
    //         Hide: !!Contact?.ID ? false : true,
    //     },
    // ], [Contact?.ID, Contact?.IsUnsubscribed, IsBlocked, openBlockConfirmDialog, openConfirmDialog]);

    const onSave = (scheduleDateTime: number, selectedScheduleTypeL: number) => {
        setScheduleDateTime(scheduleDateTime === -1 ? UtilityService.roundTimeToMinutes(new Date().getTime(), 10) : scheduleDateTime)
        setSelectedScheduleType(selectedScheduleTypeL)
        setIsMobileSchedule(false)
    }

    const SetIsMobileSchedule = (confirm: boolean) => {
        if (confirm) {
            setScheduleDateTime(-1)
            setIsMobileSchedule(!isMobileSchedule)
        }
        else {
            setScheduleDateTime(-1)
        }
    }

    const getUnSubscribedContacts = React.useCallback((boolean: boolean): number => {
        const { Campaign, IsUnsubscribed, GroupChat } = props.CardData || {};
        const phoneNumbers = Campaign?.ToPhoneNumbers;
        if (phoneNumbers) {
            const unsubscribedInList = GetUnSubscribedContacts.filter((number) => {
                return phoneNumbers?.includes(number?.PhoneNumber)
            });
            if (boolean) {
                return unsubscribedInList.length;
            } else {
                return phoneNumbers?.length - unsubscribedInList.length;
            }
        }
        return boolean ? (IsUnsubscribed ? 1 : 0) : (!!GroupChat?.ID ? GroupChat?.PhoneNumbers?.length - 1 : IsUnsubscribed ? 0 : 1)
    }, [props.CardData, GetUnSubscribedContacts]);

    const handelTransferChatfomobile = (isConfim: boolean) => {
        setShowTransferChat(isConfim)
    }

    return (
        <div className='h-p-100 o-hidden'>
            {props.IsMobileDevice && showTransferChat ?
                <TransferConversationChat
                    Show={showTransferChat}
                    HandleCloseTransfer={() => handelTransferChatfomobile(false)}
                    ContactNumber={PhoneNumber}
                />
                : props.IsMobileDevice && showContactInfo ?
                    <ContactInfoComponentNew
                        CardTitle={!!Campaign ? pageTitles.CAMPAGIN_CHAT_INFORMATION : GroupChat ? pageTitles.GROUP_CHAT_INFORMATION : pageTitles.CONTACT_INFO}
                        CloseContactInfo={() => setShowContactInfo(false)}
                        Contact={Contact ?? {
                            PhoneNumber: PhoneNumber,
                            MaskedPhoneNumber: MaskedPhoneNumber
                        } as Contact}
                        GroupChatInfo={GroupChat}
                        campaignInfo={Campaign}
                        CardData={props.CardData}
                        ActiveCardIndex={props.ActiveCardIndex}
                    />
                    // : props.IsMobileDevice && openEditContact ?
                    //     <ContactView onClose={closeEditContact}
                    //         show={openEditContact}
                    //         Contact={Contact ||
                    //             {
                    //                 PhoneNumber: PhoneNumber,
                    //                 MaskedPhoneNumber: MaskedPhoneNumber,
                    //             } as Contact
                    //         }
                    //     />
                    :
                    ((props.IsMobileDevice && !openForwordMessage) || !props.IsMobileDevice) &&
                    <div className='d-flex flex-direction h-p-100'>
                        <ConversationHistoryHeader
                            CardData={props.CardData}
                            ActiveCardIndex={props.ActiveCardIndex}
                            BackHandler={props.BackHandler}
                            HandelContactInfomobile={handelContactInfomobile}
                            // ActionsData={contactActionData}
                            HandelTransferChatfomobile={handelTransferChatfomobile}
                            IsSecureChat={props.CardData.msgType === "secure-chat"}
                            onOpenContactInfo={props.onOpenContactInfo}
                            onCloseContactInfo={props.onCloseContactInfo}

                        />
                        {!isMobileSchedule || !props.IsMobileDevice ?
                            <ConversationHistoryPage
                                activeCardIndex={props.ActiveCardIndex}
                                IsMobileDevice={props.IsMobileDevice}

                                pathName={props.pathName}
                                DeviceHeight={DeviceHeight}
                                scrollRef={props.scrollRef}
                                CardData={props.CardData}
                                OpenForwardMessage={openForwardMessage}
                                UnreadCount={props.UnreadCount}
                                onEditScheduleChange={props.onEditScheduleChange}
                                DuplicateSchedule={props.DuplicateSchedule}
                                handleSendSuggestion={(message) => { setSuggestionMessage(message) }}
                            />
                            : <ScheduleMsgMobileComponent onClose={() => { setIsMobileSchedule(false) }} onSave={onSave} selectedScheduleType={selectedScheduleType} scheduleDateTime={scheduleDateTime} IsMobileDevice={props.IsMobileDevice} IsSecureChat={props.CardData.msgType === "secure-chat"} />}
                        <div className={props.IsMobileDevice && isMobileSchedule ? "w-p-100 p-fixed b-0" : ""} style={props.IsMobileDevice ? { zIndex: 99 } : {}}>
                            <MessageComposer
                                Campaign={Campaign}
                                IsGroupChat={!!props.CardData.GroupChat ? true : false}
                                GroupChat={props.CardData?.GroupChat ? props.CardData?.GroupChat : null}
                                Limit={getUnSubscribedContacts(false)}
                                className={`w-fill`}
                                UniqId={uuid()}
                                PhoneNumbers={[props.CardData?.PhoneNumber]}
                                ContactIDs={props.CardData?.Contact?.ID ? [props.CardData?.Contact?.ID] : []}
                                UnsubscribedCount={getUnSubscribedContacts(true)}
                                BlockedCount={props.CardData?.IsBlocked ? 1 : 0}
                                IsDisabled={props.IsDisabled}
                                IsUnsubscribe={!!props.CardData?.IsUnsubscribed || !!props.CardData?.Contact?.IsUnsubscribed}
                                IsAddRule={false}
                                setIsMobileSchedule={SetIsMobileSchedule}
                                ScheduleDateTime={scheduleDateTime}
                                IsCamPaign={false}
                                ScheduleType={selectedScheduleType}
                                IsSecureChat={props.CardData.msgType === "secure-chat"}
                                SuggestionMessage={suggestionMessage}
                                ParticipantId={props.CardData?.ID}
                                GroupIDs={[]}
                                IsOptInCollected={props.CardData.IsOptInCollected}
                            />
                        </div>
                        {/* </div> */}
                    </div>
            }
            {openForwordMessage &&
                <SendMessage
                    open={openForwordMessage}
                    handleClose={() => closeForwardMessage()}
                    Message={message}
                    // Media={media}                  
                    MultiMedia={media}
                />
            }
            {/* {
                openEditContact && !props.IsMobileDevice &&
                <ContactView onClose={closeEditContact}
                    show={openEditContact}
                    Contact={Contact ||
                        {
                            PhoneNumber: PhoneNumber,
                            MaskedPhoneNumber: MaskedPhoneNumber,
                        } as Contact
                    }
                />
            } */}
            {/* {
                showConfirmDialog &&
                <ConfirmDialog
                    Show={showConfirmDialog}
                    onClose={(e: any) => { closeConfirmDialog(e) }}
                    Text={text}
                    ButtonName={dailogButtonName}
                    Loading={isloading} />
            } */}
        </div>
    )
}

export default React.memo(ConverstionHistory);